import {
    DefaultEditors,
    DashboardSettings
} from '@dev/ee-api/ee-api-models';

import * as Types from './types';
import { ApplicationState } from '..';

const { DashboardSettingsActionTypes } = Types;

export const GetDashboardSettings = (): Types.GetDashboardSettingsAction => ({
    type: DashboardSettingsActionTypes.GET_DASHBOARD_SETTINGS,
});
export const GetDashboardSettingsError = (): Types.GetDashboardSettingsErrorAction => ({
    type: DashboardSettingsActionTypes.GET_DASHBOARD_SETTINGS_ERROR,
});
export const GetDashboardSettingsSuccess = (dashboardSettingsList: DashboardSettings): Types.GetDashboardSettingsSuccessAction => ({
    type: DashboardSettingsActionTypes.GET_DASHBOARD_SETTINGS_SUCCESS,
    payload: {
        dashboardSettingsList
    }
});

export const SetDefaultEditor = (defaultEditor: DefaultEditors, showSuccessToast?:boolean): Types.SetDefaultEditorAction => ({
    type: DashboardSettingsActionTypes.SET_DEFAULT_EDITOR,
    payload: {
        defaultEditor,
        showSuccessToast
    }
});
export const SetDefaultEditorError = (): Types.SetDefaultEditorErrorAction => ({
    type: DashboardSettingsActionTypes.SET_DEFAULT_EDITOR_ERROR,
});
export const SetDefaultEditorSuccess = (): Types.SetDefaultEditorSuccessAction => ({
    type: DashboardSettingsActionTypes.SET_DEFAULT_EDITOR_SUCCESS,
});




export const getDashboardSettingsStore = (store: ApplicationState) => store?.dashboardSettings;